<template>
  <div class="rodape-acoes">
            <b-button variant="warning" @click="voltar()">
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Voltar
            </b-button>

    <div v-if="viewMode === 'tabela' && exibirBotaoSalvarAprovacaoItens">
      <b-button variant="primary" :disabled="salvandoAprovacaoItens" @click="salvarAprovacaoItens">
        <span v-if="salvandoAprovacaoItens">
          <i class="fa fa-spinner fa-spin mr-2"></i>Salvando Aprovação...
        </span>
        <span v-else>
          Salvar Aprovação dos Itens
        </span>
      </b-button>
    </div>

    <div v-if="podeExibirBotaoAtualizarMemoria">
      <b-button class="btn-blue-custom" @click="atualizarMemoria" :disabled="salvandoDados">
        <span v-if="salvandoDados && modoEdicao">
          <i class="fa fa-spinner fa-spin mr-2"></i>Salvando...
        </span>
        <span v-else>
          {{ modoEdicao && boletimEditavel ? 'Salvar alteração' : 'Atualizar Memória de Cálculo' }}
        </span>
      </b-button>
    </div>
    <div v-if="viewMode == 'GerarPdf' || (viewMode == 'tabela' && podeGerarPdfParaAssinatura)">
      <b-button class="btn-blue-custom" @click="handleGerarPdf">
        <i v-if="viewMode === 'tabela'" :class="fluxoInterno ? 'fa fa-upload mr-2' : 'fa fa-print mr-2'"></i>
        <svg v-else class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 9V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V9M3.66667 5.66667L7 9M7 9L10.3333 5.66667M7 9V1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ viewMode === 'GerarPdf' ? 'Baixar PDF' : textoBotaoGerarPdf }}
      </b-button>
    </div>
    <div v-if="viewMode == 'GerarPdf'">
      <b-button class="btn-green-custom" @click="$emit('toggle-concluir')">
          <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.00016 10.7803L3.2135 7.99365L2.27283 8.93432L6.00016 12.6617L14.0002 4.66165L13.0595 3.72098L6.00016 10.7803Z" fill="white"/>
          </svg>
          Próxima Etapa
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemoriaCalculoAcoesBtn',
  props: {
    modoEdicao: {
      type: Boolean,
      default: false
    },
    salvandoDados: {
      type: Boolean,
      default: false
    },
    viewMode: {
      type: String,
      required: true,
      default: 'tabela'
    },
    isFornecedor: {
      type: Boolean,
      default: false
    },
    boletimEditavel: {
      type: Boolean,
      default: false
    },
    temItemEditavel: {
      type: Boolean,
      default: false
    },
    podeGerarPdfParaAssinatura: {
      type: Boolean,
      default: false
    },
    textoBotaoGerarPdf: {
      type: String,
      default: 'Gerar PDF para Assinatura'
    },
    fluxoInterno: {
      type: Boolean,
      default: false
    },
    exibirBotaoSalvarAprovacaoItens: {
      type: Boolean,
      default: false
    },
    salvandoAprovacaoItens: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    podeExibirBotaoAtualizarMemoria() {
      return this.viewMode === 'tabela'
        && this.temItemEditavel
        && this.isFornecedor
        && this.boletimEditavel
    }
  },
  methods: {
    voltar() {
      this.$emit('voltar');
    },
    salvarAprovacaoItens() {
      this.$emit('salvar-aprovacao-itens');
    },
    atualizarMemoria() {
      this.$emit('toggle-edicao');
    },
    handleGerarPdf() {
      if (this.viewMode === 'tabela') {

        this.$emit('gerar-pdf');
      } else if (this.viewMode === 'GerarPdf') {

        this.$emit('download-pdf');
      }
    }
  }
};
</script>

<style scoped>
.btn-blue-custom {
    background-color: #2E60AD !important;
    border-color: #2E60AD !important;
    color: #fff !important;
}
.btn-blue-custom:hover {
    filter: brightness(0.9);
}.btn-green-custom {
    background-color: #23A26D !important;
    border-color: #23A26D !important;
    color: #fff !important;
}
.btn-green-custom:hover {
    filter: brightness(0.9);
}
.rodape-acoes {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  background-color: transparent;
  padding: 16px 16px 16px 16px;
  width: 100%;
  margin-top: 20px;
  margin-left: 0;
  margin-right: 0;
}

.btn-voltar {
  background-color: #FFC107;
  color: #333;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s;
}
</style>
